import { useState } from "react";
import { FilterIcon } from "assets/icons";
import Accordion from "components/BaseWidgets/accordion";
import { filterData as DummyData } from "components/ActivityLog/helper";
import Checkbox from "components/BaseWidgets/checkbox";
import "./style.scss";

function LeftSection({ filterData, setFilterData, isShow, setShow }) {
  const handleSingleSelect = (group, value) => {
    setFilterData((prev) => ({ ...prev, [group]: value }));
    setShow(false);
  };
  const handleMultiSelect = (group, value) => {
    setFilterData((prev) => {
      const current = prev[group] || [];
      return {
        ...prev,
        [group]: current.includes(value)
          ? current.filter((item) => item !== value)
          : [...current, value],
      };
    });
    setShow(false);
  };

  const renderOptions = (item) => {
    const isSingle = item.type === "single";
    return (
      <div className="flex flex-col gap-3">
        {item.options.map((option) => {
          const isChecked = isSingle
            ? filterData[item.id] === option.value
            : filterData[item.id]?.includes(option.value);

          return (
            <Checkbox
              isChecked={isChecked}
              key={option.value}
              onChange={() =>
                isSingle
                  ? handleSingleSelect(item.id, option.value)
                  : handleMultiSelect(item.id, option.value)
              }
            >
              {option.label}
            </Checkbox>
          );
        })}
      </div>
    );
  };

  const dateFilter = DummyData.find((item) => item.id === "period");
  const activityFilter = DummyData.find((item) => item.id === "type");

  return (
    <div
      className={`filter-container activity-filter-container ${isShow ? "visible" : "hidden"}`}
    >
      <div className="flex items-center gap-2 title-container justify-between">
        <div className="flex items-center gap-2 title-container">
          <FilterIcon />
          <h2 className="section-title font-title-normal">Filter</h2>
        </div>
        <div
          className="mob-view-closer"
          onClick={() => setShow && setShow(false)}
        >
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="32" height="32" rx="16" fill="#F2F2F2"></rect>
            <path
              d="M20.523 11.6367L11.1514 21.0083"
              stroke="#1C1D1D"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
            <path
              d="M20.523 21.0122L11.1514 11.6406"
              stroke="#1C1D1D"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
          </svg>
        </div>
      </div>
      <Accordion
        accordionClassName="filter-accordion"
        defaultActiveKey={[String(dateFilter.id)]}
        data={[
          {
            key: String(dateFilter.id),
            label: dateFilter.label,
            children: renderOptions(dateFilter),
          },
        ]}
      />

      {activityFilter && (
        <div className="flex flex-col gap-3 mt-2 activity-section">
          <h3 className="font-title-xs fw-700 leading-1">
            {activityFilter.label}
          </h3>
          {renderOptions(activityFilter)}
        </div>
      )}
    </div>
  );
}

export default LeftSection;
